import {Container} from "./Container"

export const SalesPanelStyles = {
    Container: Container
}